import React from 'react';
const RestrictAccess = ({ color = 'black', className, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        d="M1.55078 5.76923H21.5508"
        stroke={color}
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="4.62763" cy="3.46152" r="0.769231" fill={color} />
      <circle cx="6.93525" cy="3.46152" r="0.769231" fill={color} />
      <circle cx="9.24286" cy="3.46152" r="0.769231" fill={color} />
      <path
        d="M6.01232 18.0769H1.55078V1.15384H21.5508V18.0769H17.0892C17.32 18 17.5508 18 17.7816 18C17.8585 17.5385 17.9354 17 17.9354 16.5385C17.9354 16 17.8585 15.5385 17.7816 15.0769C17.0123 15.1538 16.2431 14.8461 15.8585 14.0769C15.4739 13.3846 15.5508 12.5385 16.0123 11.9231C15.32 11.2308 14.3969 10.6923 13.3969 10.3846C13.0892 11.0769 12.3969 11.6154 11.5508 11.6154C10.7046 11.6154 10.0123 11.0769 9.70463 10.3846C8.70463 10.6923 7.85847 11.2308 7.08924 11.9231C7.55078 12.5385 7.6277 13.3846 7.24309 14.0769C6.85847 14.7692 6.01232 15.1538 5.32001 15.0769C5.24309 15.5385 5.16617 16.0769 5.16617 16.5385C5.16617 17.0769 5.24309 17.5385 5.32001 18C5.55078 18 5.78155 18 6.01232 18.0769Z"
        stroke={color}
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5509 18.8462C12.8254 18.8462 13.8585 17.813 13.8585 16.5385C13.8585 15.264 12.8254 14.2308 11.5509 14.2308C10.2764 14.2308 9.24316 15.264 9.24316 16.5385C9.24316 17.813 10.2764 18.8462 11.5509 18.8462Z"
        stroke={color}
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RestrictAccess;
